import React, { useState } from 'react';
import api from '../../services/api'; // Ajuste o caminho da sua API se necessário
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

// Ícones (Design Clean)
const Icons = {
  Database: () => <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><ellipse cx="12" cy="5" rx="9" ry="3"></ellipse><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path></svg>,
  DownloadCloud: () => <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="8 17 12 21 16 17"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"></path></svg>,
  CheckCircle: () => <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>,
  Spinner: () => <svg className="spin-anim" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line></svg>
};

export default function BackupFotos() {
  const [status, setStatus] = useState('idle'); // idle, fetching, zipping, done, error
  const [progress, setProgress] = useState({ current: 0, total: 0, fotosEncontradas: 0 });
  const [log, setLog] = useState('');

  // Função auxiliar para formatar nome de arquivo
  const sanitizeName = (str) => {
    if (!str) return 'Desconhecido';
    return str.toString().replace(/[^a-zA-Z0-9]/g, '_').substring(0, 30);
  };

  const iniciarBackup = async () => {
    if (!window.confirm("Iniciar o backup de todas as fotos? Isso pode levar alguns minutos dependendo da quantidade de imagens no servidor.")) return;
    
    setStatus('fetching');
    setLog('Buscando lista de Ordens de Serviço...');
    setProgress({ current: 0, total: 0, fotosEncontradas: 0 });

    try {
      // 1. Pega a lista de todas as OS
      const resLista = await api.get('/ordens-servico');
      const ordens = resLista.data;
      
      if (!Array.isArray(ordens) || ordens.length === 0) {
        setLog('Nenhuma Ordem de Serviço encontrada.');
        setStatus('error');
        return;
      }

      setProgress(p => ({ ...p, total: ordens.length }));
      
      const zip = new JSZip();
      const pastaFotos = zip.folder("Backup_Fotos_Otica"); // Cria a pasta dentro do ZIP
      let fotosAdicionadas = 0;

      // 2. Passa de 1 em 1 OS baixando os detalhes (porque a rota de lista não traz as fotos por questão de peso)
      for (let i = 0; i < ordens.length; i++) {
        const osId = ordens[i]._id;
        setProgress(p => ({ ...p, current: i + 1 }));
        setLog(`Analisando OS ${i + 1} de ${ordens.length}...`);

        try {
          const resDetalhe = await api.get(`/ordens-servico/${osId}`);
          const osCompleta = resDetalhe.data;

          if (osCompleta.anexos && osCompleta.anexos.length > 0) {
            
            // Pega o nome e CV
            const nomeCliente = sanitizeName(osCompleta.cliente?.nome || osCompleta.cliente);
            const numeroCV = sanitizeName(osCompleta.produto?.numeroCV || (osCompleta.itens && osCompleta.itens[0]?.produto?.numeroCV) || 'SemCV');

            // 3. Adiciona cada foto no ZIP
            osCompleta.anexos.forEach((base64String, index) => {
              const matches = base64String.match(/^data:([A-Za-z-+\/]+);base64,(.+)$/);
              if (matches && matches.length === 3) {
                const tipo = matches[1].split('/')[1] || 'jpg';
                const dadosBase64 = matches[2];
                
                // Nome do arquivo: Ex: "Joao_Silva_CV_1234_foto_1.jpg"
                const nomeArquivo = `${nomeCliente}_CV_${numeroCV}_foto_${index + 1}.${tipo}`;
                
                // Salva no ZIP
                pastaFotos.file(nomeArquivo, dadosBase64, { base64: true });
                fotosAdicionadas++;
              }
            });
            
            setProgress(p => ({ ...p, fotosEncontradas: fotosAdicionadas }));
          }
        } catch (errDetalhe) {
          console.warn(`Erro ao puxar anexos da OS ${osId}`, errDetalhe);
        }
      }

      if (fotosAdicionadas === 0) {
        setLog('Nenhuma foto foi encontrada no banco de dados para fazer backup.');
        setStatus('error');
        return;
      }

      // 4. Gera o arquivo ZIP para o usuário baixar
      setStatus('zipping');
      setLog(`Compactando ${fotosAdicionadas} fotos. Aguarde...`);
      
      const conteudoZip = await zip.generateAsync({ type: 'blob' });
      
      // 5. Aciona o Download (Abre a janela perguntando onde salvar)
      saveAs(conteudoZip, `Backup_Fotos_Otica_${new Date().toISOString().split('T')[0]}.zip`);
      
      setStatus('done');
      setLog(`Backup concluído! Uma pasta com ${fotosAdicionadas} fotos foi baixada.`);

    } catch (error) {
      console.error('Erro no backup:', error);
      setStatus('error');
      setLog('Ocorreu um erro ao tentar gerar o backup.');
    }
  };

  // Cálculo da barra de progresso
  const percentual = progress.total > 0 ? Math.round((progress.current / progress.total) * 100) : 0;

  return (
    <div className="backup-container">
      <style>{`
        .backup-container { padding: 40px; max-width: 800px; margin: 0 auto; font-family: 'Plus Jakarta Sans', sans-serif; }
        .backup-card { background: #fff; border-radius: 24px; padding: 40px; box-shadow: 0 10px 40px -10px rgba(0,0,0,0.1); border: 1px solid #e2e8f0; text-align: center; }
        .icon-wrapper { width: 80px; height: 80px; background: #eef2ff; color: #4f46e5; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 24px; }
        .icon-wrapper svg { width: 40px; height: 40px; }
        .backup-title { margin: 0 0 10px 0; font-size: 28px; color: #0f172a; font-weight: 800; letter-spacing: -0.5px; }
        .backup-desc { color: #64748b; font-size: 15px; margin-bottom: 30px; line-height: 1.5; }
        
        .btn-backup { background: #4f46e5; color: white; border: none; padding: 16px 32px; border-radius: 12px; font-weight: 700; font-size: 16px; cursor: pointer; display: inline-flex; align-items: center; gap: 10px; transition: 0.3s; box-shadow: 0 4px 15px rgba(79, 70, 229, 0.3); }
        .btn-backup:hover { background: #4338ca; transform: translateY(-2px); box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4); }
        .btn-backup:disabled { background: #94a3b8; cursor: not-allowed; transform: none; box-shadow: none; }
        
        .progress-section { margin-top: 40px; text-align: left; background: #f8fafc; padding: 24px; border-radius: 16px; border: 1px solid #e2e8f0; }
        .progress-header { display: flex; justify-content: space-between; font-weight: 700; color: #334155; margin-bottom: 10px; font-size: 14px; }
        .progress-track { width: 100%; height: 8px; background: #e2e8f0; border-radius: 4px; overflow: hidden; }
        .progress-fill { height: 100%; background: #4f46e5; border-radius: 4px; transition: width 0.3s ease; }
        
        .log-text { margin-top: 15px; font-size: 13px; color: #64748b; font-weight: 600; display: flex; align-items: center; gap: 8px; }
        .stats-row { display: flex; gap: 20px; margin-top: 20px; }
        .stat-box { flex: 1; background: #fff; padding: 15px; border-radius: 12px; border: 1px solid #e2e8f0; text-align: center; }
        .stat-box span { display: block; font-size: 11px; text-transform: uppercase; color: #64748b; font-weight: 700; margin-bottom: 5px; }
        .stat-box strong { font-size: 24px; color: #0f172a; font-weight: 800; }
        
        .success-box { background: #f0fdf4; color: #15803d; border: 1px solid #bbf7d0; padding: 20px; border-radius: 16px; margin-top: 20px; display: flex; flex-direction: column; align-items: center; gap: 10px; font-weight: 600; }
        .spin-anim { animation: spin 1s linear infinite; }
        @keyframes spin { 100% { transform: rotate(360deg); } }
      `}</style>

      <div className="backup-card">
        <div className="icon-wrapper">
          <Icons.Database />
        </div>
        
        <h2 className="backup-title">Backup Geral de Imagens</h2>
        <p className="backup-desc">
          Gere um arquivo (Pasta ZIP) contendo todas as fotos e receitas anexadas no sistema.<br/>
          Você poderá escolher onde salvar no seu computador e os arquivos já virão com o nome do cliente.
        </p>

        {status === 'idle' || status === 'error' ? (
          <button className="btn-backup" onClick={iniciarBackup}>
            <Icons.DownloadCloud /> {status === 'error' ? 'Tentar Novamente' : 'Iniciar Download de Todas as Fotos'}
          </button>
        ) : null}

        {/* MENSAGEM DE ERRO (Se falhar ou não achar foto) */}
        {status === 'error' && (
          <div style={{ color: '#ef4444', marginTop: '20px', fontWeight: 'bold' }}>
            {log}
          </div>
        )}

        {/* ÁREA DE PROGRESSO */}
        {(status === 'fetching' || status === 'zipping') && (
          <div className="progress-section">
            <div className="progress-header">
              <span>{status === 'zipping' ? 'Compactando Pasta...' : 'Lendo banco de dados...'}</span>
              <span>{percentual}%</span>
            </div>
            
            <div className="progress-track">
              <div className="progress-fill" style={{ width: `${percentual}%` }}></div>
            </div>

            <div className="log-text">
               <Icons.Spinner /> {log}
            </div>

            <div className="stats-row">
               <div className="stat-box">
                  <span>OS Analisadas</span>
                  <strong>{progress.current} / {progress.total}</strong>
               </div>
               <div className="stat-box" style={{ borderColor: '#c7d2fe', background: '#eef2ff' }}>
                  <span style={{ color: '#4f46e5' }}>Fotos Encontradas</span>
                  <strong style={{ color: '#4f46e5' }}>{progress.fotosEncontradas}</strong>
               </div>
            </div>
          </div>
        )}

        {/* ÁREA DE SUCESSO */}
        {status === 'done' && (
          <div className="success-box">
            <Icons.CheckCircle />
            <span>{log}</span>
            <span style={{ fontSize: '13px', color: '#166534', fontWeight: 'normal' }}>
              Se o download não começou automaticamente, verifique a pasta de Downloads do seu navegador.
            </span>
            <button className="btn-backup" style={{ marginTop: '15px' }} onClick={() => setStatus('idle')}>
              Fazer Novo Backup
            </button>
          </div>
        )}
      </div>
    </div>
  );
}